// extracted by mini-css-extract-plugin
export default {"EditIcon":"BakeryScheduleLocationManagement_EditIcon__qNvx8"};